import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, isRef as _isRef } from "vue"

const _hoisted_1 = ["content"]
const _hoisted_2 = { class: "d-flex horizontal widget-header-inner" }
const _hoisted_3 = {
  key: 1,
  class: "web-rtc-call header-button"
}
const _hoisted_4 = {
  key: 0,
  class: "call-time"
}
const _hoisted_5 = ["title"]

import {computed, ref} from 'vue';
import SvgIcon from "~/chat/vue/misc/SvgIcon.vue";
import {WidgetStore} from "~/chat/ts/store/Widget";
import CloseIcon from "~/chat/vue/misc/CloseIcon.vue";
import TriggerUnreadedCount from "~/chat/vue/trigger/TriggerUnreadedCount.vue";
import {ConfigStore} from "~/chat/ts/store/Config";
import Delay from "~/ts/library/Delay";
import ApiCallback, {API_CALLBACK_CLOSE_SUPPORT} from "~/chat/ts/service/api/methods/ApiCallback";
import EulaModalMessage from "~/chat/vue/widget/form/fields/EulaModalMessage.vue";
import ChatHeaderTile from "~/chat/ts/service/ChatHeaderTile";
import WidgetWebRtcCall from "~/chat/ts/service/webRtc/WidgetWebRtcCall";


const __default__ = {
    name: "WidgetHeader"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    back: { type: Boolean, default: true },
    closeHandler: {}
  },
  setup(__props: any) {

let props = __props;

let eulaDisplayed = ref(false);

let headerBackground = computed(() => {
    let result = ConfigStore.headerBackground.value;
    return typeof result == "string" ? result : null;
});

let headerTile = computed(() => {
    let tile = designParams.value.headerTiles;
    return tile ? ChatHeaderTile.getUrl(tile) : null;
});


let isOpened = WidgetStore.isOpened;

let isInline = WidgetStore.inlineMode;

let designParams = computed(() => {
    return ConfigStore.siteParams.value.params.designParams;
});

let showCall = computed(() => {
    return WidgetWebRtcCall.getCurrentCall() && !WidgetWebRtcCall.isCallOverlayOpened();
})

async function close() {
    if (ConfigStore.isMobile.value) {
        await Delay.make(200);
    }
    if (computedCloseHandler.value) {
        computedCloseHandler.value();
    } else {
        //Делаем так, чтобы при последующем открытии виджета, он открывался на вкладке с чатом
        if (WidgetStore.chatTab.value != WidgetStore.currentTab.value) {
            WidgetStore.openChatTab();
        }
        WidgetStore.close();

    }
}

let computedCloseHandler = computed(() => {
    if (props.closeHandler) {
        return props.closeHandler;
    } else if (WidgetStore.inlineMode.value) {
        let search = window.location.search;
        if (ConfigStore.setup.value.showCloseButton || (search && search.indexOf("sdk-show-close-button=1") > -1)) {
            return () => {
                ApiCallback.emit(API_CALLBACK_CLOSE_SUPPORT);
            };
        }
    }
    return null;
});

//Показываем крестик в инлайн режиме только если на него навешано другое действие
let isCloseVisible = computed(() => {
    return !WidgetStore.inlineMode.value || !!computedCloseHandler.value;
});

function toggleSideMenu() {
    WidgetStore.isSideMenuOpened.value ? WidgetStore.closeSideMenu() : WidgetStore.openSideMenu();
}

let needToShowUnreadedCount = computed(() => {
    return WidgetStore.currentTab.value != WidgetStore.chatTab.value;
});

let isEulaVisible = computed(() => {
    return WidgetStore.isEulaEnabled.value && eulaConfig.value.type == "headerInfo";
});

let eulaConfig = computed(() => {
    return ConfigStore.siteParams.value.params.siteChatOptions.eula;
});

let callTime = computed(() => {
    return WidgetWebRtcCall.getCurrentCall()?.getCallTimeString();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({'widget-header widget-header-color widget-draggable-handler': true, draggable: _unref(designParams).draggable })
  }, [
    (_unref(headerTile))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "tile absolute-full-size",
          style: _normalizeStyle({
                backgroundImage: `url('${_unref(headerTile)}') !important`,
            })
        }, null, 4))
      : _createCommentVNode("", true),
    (_unref(isOpened) && !_unref(isInline) && _unref(headerBackground))
      ? (_openBlock(), _createElementBlock("meta", {
          key: 1,
          name: "theme-color",
          content: _unref(headerBackground)
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.back)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "support-back header-button",
            onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
            onPointerdown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
            onClick: toggleSideMenu
          }, [
            (_unref(needToShowUnreadedCount))
              ? (_openBlock(), _createBlock(TriggerUnreadedCount, {
                  key: 0,
                  class: "unreaded-count"
                }))
              : _createCommentVNode("", true),
            _createVNode(SvgIcon, {
              "icon-name": "bars",
              "icon-style": "light",
              class: "back-icon"
            })
          ], 32))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass({filler: true, 'slot-near-call': _unref(showCall)})
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2),
      (_unref(showCall))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "circle",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(WidgetWebRtcCall).toggleCallOverlay(true)))
            }, [
              _createVNode(SvgIcon, {
                style: {"color":"#00C853 !important"},
                "icon-name": "phone"
              }),
              (_unref(callTime))
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(callTime)), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(isEulaVisible))
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "support-close header-button",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_isRef(eulaDisplayed) //@ts-ignore
 ? eulaDisplayed.value = true : eulaDisplayed = true)),
            onMousedown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
            onPointerdown: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
            title: _unref(eulaConfig).buttonTooltip
          }, [
            _createVNode(SvgIcon, {
              class: "cursor-pointer",
              "icon-name": "info-circle",
              "icon-style": "light"
            })
          ], 40, _hoisted_5))
        : _createCommentVNode("", true),
      (_unref(isCloseVisible))
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: "support-close header-button",
            onClick: close,
            onMousedown: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
            onPointerdown: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
            onTouchend: close
          }, [
            _createVNode(CloseIcon, { class: "close-icon" })
          ], 32))
        : _createCommentVNode("", true),
      (_unref(eulaDisplayed))
        ? (_openBlock(), _createBlock(EulaModalMessage, {
            key: 4,
            visible: _unref(eulaDisplayed),
            "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => (_isRef(eulaDisplayed) ? (eulaDisplayed).value = $event : eulaDisplayed = $event))
          }, null, 8, ["visible"]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})